import { required, requiredIf, minLength, url } from "vuelidate/lib/validators";
import { dateAfter, date45Days } from "@/validation/";

const step2 = [
  "form.eventName",
  "form.eventArea",
  "form.date",
  "form.url",
  "form.q_2_4",
  "form.eventType",
  "form.editions",
  "form.audienceAmount",
  "form.q_2_8",
  "form.q_2_8a",
  "form.q_2_8b"
];

const require24 = function(m) {
  return m.q_2_4 === true;
};

const require28 = function(m) {
  return this.form.q_2_8 === true;
};

const require28a = function(m) {
  return this.form.q_2_8a === true;
};

const url2 = function(value) {
  return !value || url(value.includes("http") ? value : `https://${value}`);
};

const step2Validations = {
  eventName: { required, minLengthNazwa: minLength(3) },
  eventArea: { required },
  date: {
    $each: {
      dateStart: { required }, //, date45Days },
      dateEnd: { required, dateAfterDateStart: dateAfter("dateStart") }
    }
  },
  q_2_4: { required },
  url: {
    required: requiredIf(require24),
    url2
  },
  eventType: { required },
  editions: { required },
  audienceAmount: { required },
  q_2_8: { required },
  q_2_8a: { required: requiredIf(require28) },
  q_2_8b: { required: requiredIf(require28a) }
};

export { step2Validations, step2 };
